import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { normalizeUrl } from '@mssgme/helpers';
import { useRestrictedCard } from '@mssgme/hooks';
import { TextField } from '@mssgme/ui';
import { FieldTip } from '@mssgme/app/components/UI';
import CardEditForm from '../CardEditForm';

import styles from './UrlEdit.scss';

export default function UrlEdit() {
    const { t } = useTranslation('cards');
    const { domain } = useRestrictedCard();
    const domainValue =
        domain.name && domain.resolved
            ? domain.name
            : domain.name && !domain.resolved
                ? t('UrlEdit.values.resolving')
                : t('UrlEdit.values.notConnected');
    const domainButtonText = domain.name ? t('UrlEdit.button.edit') : t('UrlEdit.button.connect');

    return (
        <CardEditForm title={t('UrlEdit.title')} backPath="/p/settings" successRedirectPath="/p/settings">
            {() => (
                <>
                    <TextField
                        label={t('UrlEdit.labels.slug')}
                        name="profile.url"
                        placeholder={t('profileEdit.placeholder.link')}
                        beforeInput="mssg.me/"
                        mask={normalizeUrl}
                    />
                    <span className={styles.fieldLabel}>{t('UrlEdit.labels.domain')}</span>
                    <div className={styles.domainPreview}>
                        <span className={styles.domainValue}>{domainValue}</span>
                        <Link to="/p/settings/url/domain/edit" className={styles.domainButton}>
                            {domainButtonText}
                        </Link>
                    </div>
                    <FieldTip style={{ marginTop: 30 }}>{t('FieldTip.url')}</FieldTip>
                </>
            )}
        </CardEditForm>
    );
}
